module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-group"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Tryout Serial'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Tryout Serial")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v("\n            Daftar Tryout Serial\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "align-center text-body-2 blew white--text",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.createSerial()
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n                Tryout Serial\n            ")], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "items": _vm.rows,
      "headers": _vm.headers,
      "has-action": true,
      "hasOpenNewTab": true,
      "custom-pagination-total-items": _vm.rows.length,
      "custom-pagination-current-page": 1,
      "custom-pagination-per-page": 10
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.editRow($event)
      },
      "deleted": function($event) {
        _vm.dialogConfirm.function = $event;
        _vm.dialogConfirm.title =
          'Apakah anda yakin akan menghapus tryout serial ini?';
        _vm.dialogConfirm.open = true;
      },
      "openNewTab": function($event) {
        return _vm.openNewTab($event)
      }
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "506px"
    },
    model: {
      value: (_vm.dialogConfirm.open),
      callback: function($$v) {
        _vm.$set(_vm.dialogConfirm, "open", $$v)
      },
      expression: "dialogConfirm.open"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5",
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.dialogConfirm.title) + "\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                " + _vm._s(_vm.dialogConfirm.subtitle) + "\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirm.open = false
      }
    }
  }, [_vm._v("\n                    Batal\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blew",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteSerial(_vm.dialogConfirm.function)
      }
    }
  }, [_vm._v("\n                    OK\n                ")])], 1)], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19d5a0a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/serial/components/Serial.vue
// module id = 2066
// module chunks = 1